<script>
import { userService } from '@services/UserService'
import { patientService } from '@services/PatientService'
import Form from '@classes/Form'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import store from '@state/store'
import CustomSnackbar from '@components/custom-snackbar.vue'
export default {
  components: { VueTelInputVuetify, CustomSnackbar },
  data() {
    return {
      emailDialog: false,
      tryingToSaveUser: false,
      show: false,
      valid: false,
      state: [],
      credential: null,
      userData: '',
      changeData: false,
      phoneNumberError: '',
      error: false,
      userForm: new Form({
        first_name: '',
        last_name: '',
        gender: '',
        sex: '',
        credential: '',
        dob: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone_number: '',
        imperial_units: '',
      }),
      emailWarnMessages: false,
      emailErrorMessages: '',
      defaultEmail: '',
      changeDataWatch: '',
      userCredData: '',
      enableButton: false,
      // Date formater
      selectDate: null,
      dateFormatted: '',
      userMessage: '',
      date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),

      // Date formater End

      // Form Validation

      notGreekRule: [
        (v) =>
          !v || !v.length > 0 || /^[a-zA-Z0-9, ]+$/g.test(v) || 'Invalid data',
      ],
      fnameRule: [
        (v) => !!v || 'First name is required',
        (v) => /^[a-zA-Z, ]+$/g.test(v) || 'Invalid name format',
      ],

      lnameRule: [
        (v) => !!v || 'Last name is required',
        (v) => /^[a-zA-Z, ]+$/g.test(v) || 'Invalid name format',
        (v) =>
          (v && v.length <= 30) || 'Last name must be less than 30 characters',
      ],
      emailRules: [
        // input => "Input exceeds 20 characters.",
        (v) => !!v || 'Email is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      credentialRule: [(v) => !!v || 'Credential is required'],
      cityRule: [(v) => /^[A-Z]+$/g.test(v) || 'Allow only alphabets'],
      zipRule: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /^\d{5}(-\d{4})?$/.test(v) ||
          'Invalid Zip Code,It should be in the format of 12345 or 12345-1234.',
      ],
      phoneRule: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /^[0-9]{3}?[-\s.][0-9]{3}[-\s.]?[0-9]{4,6}$/.test(v) ||
          'The phone number entered is not valid.',
      ],
      onlyNumberRegex: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g.test(v) ||
          'Invalid data',
      ],
      // Form Validation End
      snackbar: false,
      snackbarMessage: '',
      showConnectedHealth: false,
    }
  },

  computed: {
    ...authComputed,

    ...optionsComputed,
    emailWarnningMsg() {
      if (/.+@.+/.test(this.userForm.email) && this.emailWarnMessages) {
        return true
      }
      return false
    },
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      } else {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      }
    },
    disableBtn() {
      if (!this.valid) {
        return true
      }

      if (this.changeData) {
        return false
      } else if (
        this.userForm.gender === '' ||
        this.userForm.sex === '' ||
        this.userForm.credential === [] ||
        this.userForm.dob === '' ||
        this.userForm.address === '' ||
        this.userForm.city === '' ||
        this.userForm.state === '' ||
        this.userForm.zip === '' ||
        this.userForm.phone_number === '' ||
        !this.changeData
      ) {
        return true
      } else {
        return null
      }
    },
  },
  watch: {
    userForm: {
      deep: true,
      handler(newValue) {
        return this.onChangeInput
      },
    },
    date(newValue) {
      this.userForm.dob = newValue
    },
  },
  async mounted() {
    // Get User Data
    const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.userOrg = userData.user.user_org_details[0].org_name
    if (this.userOrg === 'safehaven') {
      this.show = true
    }

    try {
      const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
      this.userOrg = userData.user.user_org_details[0].org_name
      if (this.userOrg === 'safehaven') {
        this.show = true
      }

      // Get PatientOptions
      const patientOptions = (await patientService.options()).data
      if (patientOptions) {
        this.maritalStatus = patientOptions.marital_status
        this.race = patientOptions.race
        this.credential = patientOptions.credentials
        this.state = patientOptions.states
        this.sex = patientOptions.sex
        this.gender = patientOptions.gender
      }

      const user = (await userService.getUser(this.currentUser.user.user_id))
        .data
      localStorage.setItem('userData', JSON.stringify(user))
      this.showConnectedHealth = user.is_connected_health
      this.toggleConnectedHealth(this.showConnectedHealth)
      if (user) {
        this.userData = user
        this.updateUserInfo()
        this.userForm.credential =
          user.credential && user.credential.length
            ? user.credential[0].credential_id
            : null

        this.userCredData = this.userForm.credential
      }

      // Get PatientData
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
    ...authMethods,
    onchangeEmail() {
      if (this.defaultEmail !== this.userForm.email) this.emailDialog = true
      else this.tryToSaveUser()
    },
    continueWithEmail() {
      this.emailDialog = false
      this.tryToSaveUser()
    },
    updateUserInfo() {
      this.userForm.first_name = this.currentUser.user.first_name
      this.userForm.last_name = this.currentUser.user.last_name

      this.userForm.email = this.currentUser.user.email
      this.defaultEmail = this.currentUser.user.email
      this.userForm.dob = this.currentUser.user.dob
      this.date = this.currentUser.user.dob
      this.userForm.sex = this.currentUser.user.sex
      this.userForm.imperial_units = this.currentUser.user.imperial_units
      this.userForm.gender = this.currentUser.user.gender
      this.savedProfilePhoto = this.currentUser.user.profile_picture
        ? this.currentUser.user.profile_picture
        : null

      this.userForm.address = this.userData.address
      this.userForm.city = this.userData.city
      this.userForm.state = this.userData.state.values
      this.userForm.zip = this.userData.zip_code
      this.userForm.phone_number = this.userData.phone_number
    },
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z, ]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    isNotLetter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    validate() {
      this.$refs.form.validate()
      if (this.valid) this.enableButton = true
    },
    onChangeInput() {
      this.changeData = true
      this.successMessage = null
      this.phoneNumberError = null
    },

    chnageEmail() {
      this.emailWarnMessages = true
      this.emailErrorMessages = null
    },

    async tryToSaveUser() {
      this.$refs.form.validate()
      this.tryingToSaveUser = true
      this.emailWarnMessages = false
      if (this.valid) {
        if (this.userOrg === 'safehaven' && this.userForm.credential) {
          this.userErrors = null
          this.userMessage = ''
          const cred = this.credential.find(
            (x) => x.credential_id === this.userForm.credential
          )

          const Obj = this.userForm.data()
          if (cred) Obj.credential = [cred]
          Obj.dob = this.date
          Obj.state = this.userForm.state ? this.userForm.state : null
          Obj.is_connected_health = this.showConnectedHealth
          try {
            const userResponse = (
              await userService.update(this.currentUser.user.user_id, Obj)
            ).data
            if (userResponse) {
              this.snackbarMessage = 'Saved Successfully'
              this.snackbar = true
              setTimeout(() => {
                this.snackbar = false
              }, 3000)
              this.toggleConnectedHealth(this.showConnectedHealth)
              await store.dispatch('auth/fetchUser')
              this.userMessage = 'Changes Saved'
              const userObj = JSON.parse(
                localStorage.getItem('auth.currentUser')
              )
              userObj.user.imperial_units = this.userForm.imperial_units
              localStorage.setItem('auth.currentUser', JSON.stringify(userObj))

              this.userData.address = this.userForm.address
              this.userData.city = this.userForm.city
              this.userData.state.values = this.userForm.state
              this.userData.zip_code = this.userForm.zip
              this.userData.phone_number = this.userForm.phone_number
            }
          } catch (error) {
            this.userErrors = error
            this.userForm.onFail(error.response.data)
            if (error.response.data.phone_number)
              this.phoneNumberError = error.response.data.phone_number[0]
            this.error = true
            this.emailErrorMessages = error.response.data.email
            this.snackbarMessage = 'Saved Successfully'
            this.snackbar = false
          }

          this.tryingToSaveUser = false
        } else if (this.userOrg !== 'safehaven') {
          this.userErrors = null
          this.userMessage = ''
          const cred = {}
          const Obj = this.userForm.data()
          if (cred) Obj.credential = {}
          Obj.dob = this.date
          Obj.state = this.userForm.state ? this.userForm.state : null
          try {
            const userResponse = (
              await userService.update(this.currentUser.user.user_id, Obj)
            ).data
            if (userResponse) {
              this.snackbarMessage = 'Saved Successfully'
              this.snackbar = true
              setTimeout(() => {
                this.snackbar = false
              }, 3000)
              this.toggleConnectedHealth(this.showConnectedHealth)
              this.changeData = false
              await store.dispatch('auth/fetchUser')
              this.userMessage = 'Changes Saved'
              const userObj = JSON.parse(
                localStorage.getItem('auth.currentUser')
              )
              userObj.user.imperial_units = this.userForm.imperial_units
              localStorage.setItem('auth.currentUser', JSON.stringify(userObj))
              this.userData.address = this.userForm.address
              this.userData.city = this.userForm.city
              this.userData.state.values = this.userForm.state
              this.userData.zip_code = this.userForm.zip
              this.userData.phone_number = this.userForm.phone_number
            }
          } catch (error) {
            this.userErrors = error
            this.userForm.onFail(error.response.data)
            if (error.response.data.phone_number)
              this.phoneNumberError = error.response.data.phone_number[0]
            this.error = true
            this.emailErrorMessages = error.response.data.email
          }

          this.tryingToSaveUser = false
        }
      }
    },

    reset() {
      this.updateUserInfo()
      this.userForm.credential = this.userCredData
    },
    toggleConnectedHealth(value) {
      this.$emit('show-connected', value)
    },
  },
}
</script>

<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    :class="$style.form"
    @submit.prevent="validate"
  >
    <v-container>
      <v-row class="mt-1">
        <v-col cols="12" md="12" class="pb-0">
          <label> First Name<span :class="$style.mandatory">*</span> </label>
          <v-text-field
            v-model="userForm.first_name"
            :rules="fnameRule"
            :maxlength="30"
            required
            outlined
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="12" class="py-0">
          <label> Last Name<span :class="$style.mandatory">*</span> </label>
          <v-text-field
            v-model="userForm.last_name"
            :rules="lnameRule"
            :maxlength="30"
            outlined
            required
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="show" cols="6" md="6" sm="6" xs="6" class="py-0">
          <label> Credential<span :class="$style.mandatory">*</span> </label>
          <v-select
            v-model="userForm.credential"
            :items="credential"
            :rules="tryingToSaveUser ? credentialRule : []"
            item-text="credential_name"
            item-value="credential_id"
            outlined
            required
            @change="onChangeInput"
          ></v-select>
        </v-col>

        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <v-menu
            v-model="selectDate"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <label> Date of Birth</label>
              <v-text-field
                slot="activator"
                :class="$style.dateInput"
                :value="computedDateFormatted"
                :rules="[(v) => !!v || 'Required']"
                append-icon="mdi-calendar-blank"
                outlined
                readonly
                v-on="on"
                @click:append="on.click"
                @focus="onChangeInput"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              :max="new Date().toISOString().substr(0, 10)"
              @change="selectDate = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <label> E-mail<span :class="$style.mandatory">*</span> </label>
          <v-text-field
            v-model="userForm.email"
            :class="hasMfa ? $style.disableEmailInput : $style.emailInput"
            :rules="emailRules"
            append-icon="mdi-email-outline"
            :error-messages="emailErrorMessages"
            outlined
            required
            :disabled="hasMfa"
            @keydown="onChangeInput"
            @keyup="chnageEmail"
          ></v-text-field>
          <p v-if="emailWarnningMsg" :class="$style.WarningMsg"
            >Email is required for sign in. Verify your change for accuracy.</p
          >
          <div v-if="hasMfa">
            <label :class="$style.mfaErrorMessage"
              >You must disable 2FA in Security Settings before editing
              email</label
            >
            <label
              :class="$style.gotoSecuritySettingsLink"
              @click="$emit('goto-security-settings')"
              >Go to Security Settings</label
            >
          </div>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Street Address</label>
          <v-text-field
            v-model="userForm.address"
            :rules="notGreekRule"
            :maxlength="100"
            outlined
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <label> City</label>
          <v-text-field
            v-model="userForm.city"
            :rules="notGreekRule"
            :maxlength="30"
            outlined
            required
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="9" md="9" sm="9" xs="9" class="py-0">
          <label> State</label>
          <v-select
            v-model="userForm.state"
            :items="state"
            item-text="value"
            item-value="value"
            outlined
            @change="onChangeInput"
          ></v-select>
        </v-col>
        <v-col cols="3" md="3" sm="3" xs="3" class="py-0">
          <label> ZIP </label>
          <v-text-field
            v-model="userForm.zip"
            :rules="zipRule"
            placeholder="12345"
            :minlength="5"
            :maxlength="10"
            outlined
            @keypress="isNotLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <label> Phone number </label>
          <VueTelInputVuetify
            v-model="userForm.phone_number"
            default-country="US"
            outlined
            :max-len="15"
            :rules="onlyNumberRegex"
            placeholder="555-555-5555"
            :only-countries="['US']"
            mode="international"
            label=""
            :error-messages="phoneNumberError"
            @keydown="onChangeInput(), isNotLetter($event)"
          ></VueTelInputVuetify>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <v-radio-group
            v-model="userForm.imperial_units"
            label="Measurement System"
            hide-details
            class="mb-4"
            row
            @change="onChangeInput"
          >
            <v-radio :class="$style.radioClss" label="Imperial" :value="true">
            </v-radio>
            <v-radio :class="$style.radioClss" label="Metric" :value="false">
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            depressed
            :class="[
              'primary-btn',
              disableBtn && 'disabled-btn',
              $vuetify.breakpoint.mobile && 'full-width-btn',
            ]"
            @click.prevent="onchangeEmail"
          >
            Save
          </v-btn>
          <v-btn depressed :class="$style.cancelbtn" @click="reset">
            Cancel
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="emailDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5"> Email Alert </v-card-title>
          <v-card-text
            >Changing your email will require confirmation the next time you
            sign in.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="emailDialog = false">
              Cancel
            </v-btn>
            <v-btn color="green darken-1" text @click="continueWithEmail">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <CustomSnackbar
          :snackbar="snackbar"
          :snackbar-message="snackbarMessage"
        />
      </div>
    </v-container>
  </v-form>
</template>

<style lang="scss" module>
@import '@design';

.mandatory {
  color: #da1414;
}
.form label {
  display: inline-block;
  margin-bottom: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}
.radioClss {
  padding-left: 20px;
}
.radioClss label {
  margin-bottom: 0 !important;
  font-size: 14px !important;
  font-weight: normal !important;
}
.switchRow {
  align-items: center;
  justify-content: flex-start;
  margin-left: 2px;
}
.switchLabel {
  font-family: 'Open Sans', 'Inter', sans-serif !important;
  font-size: 14px;
}
.savebtn {
  width: 120px;
  height: 45px !important;
  margin-right: 20px;
  font-size: 14px !important;
  text-transform: capitalize;
  border-radius: 30px !important;
}
.cancelbtn {
  width: 120px;
  height: 45px !important;
  font-size: 14px !important;
  text-transform: capitalize;
  background-color: transparent !important;
  border-radius: 30px !important;
}
.successMessage {
  font-size: 14px;
  font-weight: bold;
}
.errorMessage {
  margin-bottom: 10px;
  font-size: 12px;
  color: #da1414;
}
.WarningMsg {
  padding: 0 13px;
  margin-top: -3px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #fb8c00 !important;
}
.emailInput fieldset {
  border-color: initial;
}
.disableEmailInput fieldset {
  border: 1px solid #f00 !important;
}
.mfaErrorMessage {
  display: block !important;
  color: #da1414 !important;
}
.gotoSecuritySettingsLink {
  padding-bottom: 10px;
  color: #0476d9 !important;
  cursor: pointer;
}
@media screen and (max-width: 959px) {
  .form label {
    font-size: 11px;
  }
}
@media screen and (max-width: 599px) {
  .savebtn,
  .cancelbtn {
    width: 100%;
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 479px) {
  .radioClss {
    padding-left: 5px;
  }
}
@media screen and (max-width: 400px) {
  .form label {
    font-size: 10px;
  }
}
</style>

<style scoped>
/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}
/deep/ .v-text-field--outlined fieldset {
  border-color: #c4c4c4;
}
/deep/ .v-text-field--outlined.error--text fieldset {
  border-color: #ca024f;
}
/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #93c0e8 !important;
}

/deep/ .v-input--radio-group--row .v-input--radio-group__input > .v-label {
  padding-right: 22px;
}
/deep/ .v-select__selection--comma {
  font-size: 14px;
}
/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
/deep/.theme--light.v-select .v-select__selections {
  font-size: 14px;
}

@media screen and (max-width: 479px) {
  .v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 0;
  }
  /deep/ .v-input--radio-group--row .v-input--radio-group__input > .v-label {
    padding-right: 0;
  }
}
</style>
